import React, { useState } from 'react';
import useStyle from './accordion.style';

export interface AccordionProps {
  children?: any;
  title: string;
  defaultIsOpen?: boolean;
  innerContent?: boolean;
  onClick?: () => void;
  icon?: JSX.Element;
}

export const Accordion = ({
  children,
  title,
  defaultIsOpen = false,
  innerContent = false,
  icon,
  onClick
}: AccordionProps) => {
  const classes = useStyle();
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const expendTransition = (target: any) => {
    const sectionHeight = target.scrollHeight;
    target.style.height = sectionHeight + 'px';
  };

  const collapseTransition = (target: any) => {
    target.style.height = null;
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    isOpen ? collapseTransition(e.target) : expendTransition(e.target);
    setIsOpen(!isOpen);
    onClick && onClick();
  };

  return (
    <div
      onClick={handleClick}
      className={`${classes.root} ${
        innerContent ? classes.inside : classes.outside
      } ${isOpen ? classes.on : classes.off} `}
    >
      <div className={classes.header}>
        <div className={classes.title}>
          {icon && icon}
          <span>{title}</span>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`${classes.arrow} ${
            isOpen ? classes.arrowon : classes.arrowoff
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      {children}
    </div>
  );
};
